import { Check, ChevronsUpDown, Globe } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/DropdownMenu"
import { MARKET_BLOCK } from "@/components/layout/MarketBlock"
import MarketFlag from "@/components/layout/MarketFlag"
import type { Market } from "@/lib/useMarket"

interface Props {
  market: Market | null
  markets: Market[]
  onChange: (market: Market) => void
}

// The panel's own market, a full-height block in its navy strip that looks
// like the top bar's market block. Picking one here changes only the panel,
// never the remembered market or the page behind it.
export default function MarketSwitcher({ market, markets, onChange }: Props) {
  if (markets.length === 0) return null
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className={`${MARKET_BLOCK} transition-colors hover:bg-top-bar-hover data-[state=open]:bg-top-bar-hover`}>
          {market ? <MarketFlag market={market} /> : <Globe size={15} />}
          {market ? market.name : "Pick a market"}
          <ChevronsUpDown size={14} className="ml-auto text-top-bar-muted-foreground" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[200px]">
        {markets.map((m) => (
          <DropdownMenuItem key={m.id} onSelect={() => onChange(m)} className="justify-between gap-2">
            <span className="flex items-center gap-2">
              <MarketFlag market={m} />
              {m.name}
            </span>
            {market?.id === m.id && <Check size={14} className="text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
